import { render, staticRenderFns } from "./DocumentComplianceEditor.vue?vue&type=template&id=520863d2&"
import script from "./DocumentComplianceEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentComplianceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports